type RichTextMentionEditor = {
  getSelection?: () => { index: number } | null;
  getLength?: () => number;
  getText?: () => string;
  deleteText?: (start: number, length: number) => void;
  insertText?: (start: number, text: string) => void;
  setText?: (text: string) => void;
  setSelection?: (index: number, length: number) => void;
};

export const getMentionBounds = (
  plainText: string,
  cursorPosition: number,
  fallbackSearchText: string
) => {
  const beforeCursor = plainText.slice(0, cursorPosition);
  const match = beforeCursor.match(/(^|\s)@([A-Za-z0-9_-]*)$/);

  if (match) {
    return {
      start: cursorPosition - match[2].length - 1,
      end: cursorPosition,
    };
  }

  if (fallbackSearchText) {
    const fallbackNeedle = `@${fallbackSearchText}`;
    const fallbackStart = plainText.lastIndexOf(fallbackNeedle);

    if (fallbackStart >= 0) {
      return {
        start: fallbackStart,
        end: fallbackStart + fallbackNeedle.length,
      };
    }
  }

  return {
    start: Math.max(0, cursorPosition - fallbackSearchText.length - 1),
    end: cursorPosition,
  };
};

export const insertCommentMention = ({
  editor,
  currentText,
  searchText,
  username,
}: {
  editor?: RichTextMentionEditor | null;
  currentText: string;
  searchText: string;
  username: string;
}) => {
  const normalizedUsername = String(username ?? '').replace(/^@/, '').trim();

  if (!normalizedUsername) {
    return currentText;
  }

  const mentionText = `@${normalizedUsername} `;
  const range = editor?.getSelection?.();
  const position = range
    ? range.index
    : Math.max(0, (editor?.getLength?.() ?? currentText.length + 1) - 1);
  const plainText = editor?.getText?.() ?? currentText;
  const { start, end } = getMentionBounds(plainText, position, searchText);
  const nextText = `${plainText.slice(0, start)}${mentionText}${plainText.slice(end)}`;

  if (editor?.deleteText && editor?.insertText) {
    editor.deleteText(start, end - start);
    editor.insertText(start, mentionText);
    editor.setSelection?.(start + mentionText.length, 0);
  } else if (editor?.setText) {
    editor.setText(nextText);
    editor.setSelection?.(start + mentionText.length, 0);
  }

  return nextText;
};
